const REGEX = /["a-zA-Z-0-9.:,()ÀÂÇÈÉÊËÎÔÙÛàâçèéêëîôöùû+=><_°&%Ã©  /’'–-]{1,100}/gm;

export function parseGoogleAddress(formattedAddress) {
  if (!formattedAddress) return null;

  const regexComplet = /^(.+?),\s*(\d{5})\s+(.+?),\s*(.+)$/;
  const matchComplet = formattedAddress.match(regexComplet);
  if (matchComplet) {
    const [, intitule, codePostal, ville, pays] = matchComplet;
    return {
      intitule, codePostal, ville, pays,
    };
  }
  
  const regexSansIntitule = /^\s*(\d{5})\s+(.+?),\s*(.+)$/;
  const matchSansIntitule = formattedAddress.match(regexSansIntitule);
  if (matchSansIntitule) {
    const [, codePostal, ville, pays] = matchSansIntitule;
    return {
      intitule: '', codePostal, ville, pays,
    };
  }
  const segments = formattedAddress.split(',').map(segment => segment.trim()).filter(segment => !!segment);
  if (segments.length >= 2) {
    const pays = segments[segments.length - 1];
    const ville = segments[segments.length - 2];
    return {
      intitule: segments.slice(0, -2).join(', '),
      codePostal: null,
      ville,
      pays,
    };
  }

  return null;
}

function genererDefaultAdresse() {
  return {
    adresse1: null,
    adresse2: null,
    adresse3: null,
    pays: null,
    ville: null,
    codePostal: null,
    departement: null,
    agglomeration: null,
    intitule1: null,
    intitule2: null,
    intitule3: null,
    latitude: null,
    longitude: null,
    coordonnees: { lat: null, lng: null },
  };
}

export function getCoordonneesInData(data) {
  if (!data) return null;
  const { coordonnees } = data;
  if (!coordonnees || !coordonnees.lat || !coordonnees.lng) return null;
  return coordonnees;
}

export function getCoordonneesByAdresse(adresse) {
  if (adresse.coordonnees) return adresse.coordonnees;
  return { lat: adresse.latitude, lng: adresse.longitude };
}

export function getAdresseByGescomAdresse(adresse) {
  if (!adresse) return genererDefaultAdresse();
  return {
    ...adresse,
    coordonnees: getCoordonneesByAdresse(adresse),
  }
}

export function formatAdresseConcurrent(client) {
  const adresseFormater = genererDefaultAdresse();
  if (!client.adressePostale) {
    const match =  client.adresse.match(REGEX);
    const formattedAdresse = parseGoogleAddress(client.adresse);
    adresseFormater.adresse1 =  match && match.length >= 1 ? match[0] : '';
    adresseFormater.adresse2 = match && match.length >= 2 ? match[1] : '';
    adresseFormater.adresse3 = match && match.length >= 3 ? match[2] : '';
    adresseFormater.intitule1 = client.name;
    adresseFormater.latitude = client.position.lat;
    adresseFormater.longitude = client.position.lng;
    if (formattedAdresse) {
      adresseFormater.pays = formattedAdresse.pays;
      adresseFormater.ville = formattedAdresse.ville;
      adresseFormater.codePostal = formattedAdresse.codePostal;
    }
  } else {
    const adresse1 = [];
    if (client.adressePostale.numberRue) adresse1.push(client.adressePostale.numberRue);
    if (client.adressePostale.libelleRue) adresse1.push(client.adressePostale.libelleRue);
    const match = adresse1.join(', ').match(REGEX);
    adresseFormater.adresse1 = match && match.length >= 1 ? match[0] : '';
    adresseFormater.latitude = client.adressePostale.coordonnees.lat;
    adresseFormater.longitude = client.adressePostale.coordonnees.lng;
    adresseFormater.ville = client.adressePostale.ville;
    adresseFormater.intitule1 = client.name;
    adresseFormater.pays = client.adressePostale.pays;
    adresseFormater.codePostal = client.adressePostale.codePostal;
    adresseFormater.adresse2 = match && match.length >= 2 ? match[1] : '';
    adresseFormater.adresse3 = match && match.length >= 3 ? match[2] : '';
  }
  return adresseFormater;
}

export default function generer(adresse) {
  if (!adresse) return genererDefaultAdresse();
  let libelleAdresse =  adresse.adresse1;
  if (!libelleAdresse) {
    libelleAdresse = [adresse.numberRue, adresse.libelleRue].filter(libelle => !!libelle).join(', ') || adresse.libelle;
  }

  const match = [libelleAdresse, adresse.adresse2,
    adresse.adresse3].filter(libelle => !!libelle).join(', ').match(REGEX);
  return {
    ...genererDefaultAdresse(),
    intitule1: match && match.length >= 1 ? match[0] : '',
    adresse1: match && match.length >= 1 ? match[0] : '',
    adresse2:  match && match.length >= 2 ? match[1] : '',
    adresse3:  match && match.length >= 3 ? match[2] : '',
    pays: adresse.pays,
    ville: adresse.ville ? adresse.ville : adresse.pays,
    codePostal: adresse.codePostal,
    latitude: adresse.coordonnees.lat,
    longitude: adresse.coordonnees.lng,
    coordonnees: adresse.coordonnees,
  };
}
